import { createStore, applyMiddleware, compose } from "redux";
import { createReducer } from "reducers/createReducer.js";
import { routerMiddleware } from "connected-react-router";
import { thunk } from "redux-thunk";
import LogRocket from "logrocket";
import { queryBuilderFiltersApi } from 'components/QueryBuilder/services/queryBuilderFiltersApi';

const composeEnhancers = 
	(process.env.NODE_ENV !== "production" &&  window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;

const initializeStore = (history) => {
	const store = createStore(
		createReducer({ history }),
		composeEnhancers(applyMiddleware(
			thunk,
			routerMiddleware(history),
			queryBuilderFiltersApi.middleware,
			LogRocket.reduxMiddleware({
				stateSanitizer(state) {
					return {
						...state,
						base: {
							analysis: undefined,
							content: undefined,
							dataStoreMap: undefined,
							dataStoreEntities: undefined,
							dataStoreGraph: undefined,
							dataStoreContent: undefined,
							dataStoreFilters: undefined,
						},
						leftCompare: {
							analysis: undefined,
							content: undefined,
							dataStoreMap: undefined,
							dataStoreMapDetail: undefined,
							dataStoreEntities: undefined,
							dataStoreGraph: undefined,
							dataStoreGraphDetail: undefined,
							dataStoreContent: undefined,
						},
						rightCompare: {
							analysis: undefined,
							content: undefined,
							dataStoreMap: undefined,
							dataStoreMapDetail: undefined,
							dataStoreEntities: undefined,
							dataStoreGraph: undefined,
							dataStoreGraphDetail: undefined,
							dataStoreContent: undefined,
						},
					};
				},
			})
		))
	);

	store.asyncReducers = {};
	store.injectReducer = (key, reducer) => {
		store.asyncReducers[key] = reducer;
		store.replaceReducer(createReducer({ asyncReducers: store.asyncReducers, history }));
		return store;
	};

	return store;
};

export default initializeStore;
